'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _VstSubmenuItem = require('./VstSubmenuItem');

var _VstSubmenuItem2 = _interopRequireDefault(_VstSubmenuItem);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var rightArrow = function rightArrow(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '6.1',
      height: '107',
      viewBox: '0 0 6.1 10'
    }, props),
    _react2.default.createElement('path', {
      fill: '#1B1B26',
      d: 'M.1 1.4L1.3 0l4.8 4.8v.4L1.3 10 0 8.6 3.6 5z'
    })
  );
};

var VstListItem = function (_VstComponent) {
  _inherits(VstListItem, _VstComponent);

  function VstListItem(props) {
    _classCallCheck(this, VstListItem);

    var _this = _possibleConstructorReturn(this, (VstListItem.__proto__ || Object.getPrototypeOf(VstListItem)).call(this, props));

    _this.state = {
      visible: false
    };

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(VstListItem, [{
    key: 'render',
    value: function render() {
      return {
        text: this.text.bind(this),
        header: this.header.bind(this),
        subheader: this.subheader.bind(this),
        divider: this.divider.bind(this),
        element: this.element.bind(this),
        select: this.select.bind(this)
      }[this.props.role]();
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      var _props = this.props,
          closeMenu = _props.closeMenu,
          closeOnClick = _props.closeOnClick,
          onClick = _props.onClick;

      if (onClick) {
        onClick(e);
      }
      if (closeMenu && closeOnClick) {
        closeMenu();
      }
    }
  }, {
    key: '_getCSS',
    value: function _getCSS() {
      var rule = {
        '&:hover, &:active, &:focus': {
          outline: 'none',
          backgroundColor: this._theme(1)
        }
      };
      if (this.props.selected) {
        rule.color = this._theme(8);
      }
      return (0, _glamor.css)(rule);
    }
  }, {
    key: 'text',
    value: function text() {
      var _props2 = this.props,
          className = _props2.className,
          children = _props2.children,
          style = _props2.style,
          selected = _props2.selected;


      return _react2.default.createElement(
        'li',
        _extends({
          className: 'vst-list-item text ' + className + ' ' + (selected ? 'selected' : '')
        }, this._getCSS()),
        _react2.default.createElement(
          'div',
          _extends({
            className: 'libutton',
            tabIndex: 0,
            role: 'button',
            style: style,
            'aria-pressed': selected,
            onClick: this.onClick
          }, this._getCSS()),
          children
        )
      );
    }
  }, {
    key: 'header',
    value: function header() {
      var _props3 = this.props,
          className = _props3.className,
          children = _props3.children,
          style = _props3.style;

      return _react2.default.createElement(
        'li',
        {
          className: 'vst-list-item header ' + className,
          style: style,
          tabIndex: -1
        },
        children
      );
    }
  }, {
    key: 'subheader',
    value: function subheader() {
      var _props4 = this.props,
          className = _props4.className,
          children = _props4.children,
          style = _props4.style;

      return _react2.default.createElement(
        'li',
        {
          className: 'vst-list-item subheader ' + className,
          style: style,
          tabIndex: -1
        },
        _react2.default.createElement(
          'h3',
          null,
          children
        )
      );
    }
  }, {
    key: 'divider',
    value: function divider() {
      var _React$createElement;

      return _react2.default.createElement('li', (_React$createElement = {
        className: 'vst-list-item subheader',
        tabIndex: this.props.tabIndex
      }, _defineProperty(_React$createElement, 'tabIndex', -1), _defineProperty(_React$createElement, 'style', { padding: 0 }), _React$createElement));
    }
  }, {
    key: 'element',
    value: function element() {
      var _props5 = this.props,
          className = _props5.className,
          children = _props5.children,
          style = _props5.style,
          selected = _props5.selected;


      return _react2.default.createElement(
        'li',
        _extends({
          className: 'vst-list-item element ' + className + ' ' + (selected ? 'selected' : ''),
          style: style,
          'aria-pressed': selected
        }, this._getCSS()),
        children
      );
    }
  }, {
    key: 'select',
    value: function select() {
      var _this2 = this;

      var _props6 = this.props,
          className = _props6.className,
          children = _props6.children,
          style = _props6.style,
          text = _props6.text,
          selected = _props6.selected,
          isList = _props6.isList,
          restProps = _objectWithoutProperties(_props6, ['className', 'children', 'style', 'text', 'selected', 'isList']);

      var openSubmenu = function openSubmenu() {
        _this2.setState({ show: true });
        // setTimeout(() => this.submenu.submenu.firstChild.firstChild.focus(), 1000);
        // submenu.firstChild.focus();
      };
      return _react2.default.createElement(
        'li',
        _extends({
          className: 'vst-list-item select ' + className + ' ' + (selected ? 'selected' : ''),
          onMouseEnter: openSubmenu,
          onClick: openSubmenu,
          onFocus: openSubmenu
        }, restProps, this._getCSS()),
        _react2.default.createElement(
          'div',
          _extends({
            className: 'libutton',
            tabIndex: 0,
            role: 'button',
            style: style,
            onClick: openSubmenu,
            onMouseEnter: openSubmenu,
            onFocus: openSubmenu,
            'aria-pressed': selected
          }, this._getCSS()),
          text,
          _react2.default.createElement(
            _VstSubmenuItem2.default,
            {
              ref: function ref(submenu) {
                _this2.submenu = submenu;
              },
              closeMenu: this.props.closeMenu,
              visible: this.state.show,
              isMobile: this.props.isMobile,
              isList: isList,
              onBackButtonClick: function onBackButtonClick() {
                return _this2.setState({ show: false });
              },
              headerTitle: this.props.headerTitle,
              headerClassName: this.props.headerClassName,
              headerApplyButton: this.props.headerApplyButton,
              headerBackButton: this.props.headerBackButton
            },
            children
          ),
          rightArrow()
        )
      );
    }
  }]);

  return VstListItem;
}(_VstComponent3.default);

VstListItem.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  closeMenu: _propTypes2.default.func,
  closeOnClick: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number,
  text: _propTypes2.default.string,
  hidden: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  maxHeight: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  role: _propTypes2.default.oneOf(['text', 'header', 'subheader', 'divider', 'element', 'select'])
};

VstListItem.defaultProps = {
  role: 'text',
  className: '',
  style: {},
  hidden: false,
  maxHeight: undefined,
  closeOnClick: true
};

exports.default = VstListItem;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstListItem.js
 **/